<div class="row ss-top-menu">
  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard <i
        class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">CM- City GM Mapping</span>
  </div>
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
    <input class="form-control mr-sm-2" type="text" [(ngModel)]="searchItem" placeholder="Name/ Email ID"
      style="font-size: 12px;">
  </div>
  <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 px-0">
    <button class="searchBtn" (click)="getCMList(searchItem)">Search</button>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="tableDiv table-responsive">
      <p *ngIf="cm_list && cm_list.length === 0" class="text-center">No Leads Available</p>
      <table class="table" *ngIf="cm_list && cm_list.length > 0">
        <thead>
          <tr>
            <th class="firstTh">#</th>
            <th class="addCursor">Name</th>
            <th>Contact</th>
            <th>Email</th>
            <th>Last Status Update</th>
            <th>Assigned General Manager</th>
            <th>Assign General Manager</th>
            <th class="text-center activeCol lastTh">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cm of cm_list, let i = index;" [attr.data-index]="i">
            <td>{{i+1}}</td>
            <td class="minWidthForTd capitalize">{{cm.name}}</td>
            <td class="minWidthForTd">{{cm.contact}}</td>
            <td class="minWidthForTd">{{cm.email}}</td>
            <td class="minWidthForTd">{{cm.assigned_gm_date_time | date:'dd MMM, y , h:mm a'}}</td>
            <td class="minWidthForTd">{{cm.assigned_gm_name}}</td>
            <td class="minWidthForTd">
              <select class="form-control" (change)="onDropdownChange(cm.id,$event.target.value,i)"
                id="assigndropdown{{cm.id}}" style="width: 77%; display: inline-block;font-size: 14px;">
                <option>Assign To General Manager</option>
                <option *ngFor="let agent of gm_list" value={{agent.id}}>{{agent.name}} - {{agent.email}}</option>
              </select>
              <img src="assets/v3/img/sendbutton1.svg" class="ml-1 sendIcon addCursor"
                (click)="assignLeadToAgent(cm.id,i)">
            </td>
            <td class="text-center">
              <i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash addCursor"
                aria-hidden="true" data-toggle="modal" data-target="#deleteGm"
                (click)="getDataofRemoveGm(cm.id,cm.assigned_gm_id)" *ngIf="cm.assigned_gm_id"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<!-- The Remove GM Modal -->
<div class="modal" id="deleteGm">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Remove General Manager</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Do you want to remove assigned General Manager
      </div>

      <!-- Modal footer -->
      <div class="modal-footer border-0">
        <button type="button" class="btn searchBtn" (click)="removeGm()">Yes</button>
        <button type="button" class="btn searchBtn" data-dismiss="modal">No</button>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-gm-mapping/cm-gm-mapping.component.html